import { G } from '@/_common';

export const user_stores = {
    data: {
        allDataTableParams: {
            "default": {
                first: 0,
                originalEvent: {
                    first: 0,
                    page: 1,
                    rows: G.rowsPerPage
                },
                page: 1,
                rows: G.rowsPerPage,
                mainFilters: {},
                multiSortMeta: [],
                filters: '',
                whereIf: ''
            },
        },
    },

    api: {
        menu:                                   '/menu/{lang}/',
        menu_list:                              '/menu/{lang}/list',
        menu_update:                            '/menu/{lang}/{menu_id}',
        menu_activate:                          '/menu/{lang}/activate/{menu_id}/{isactive}',

        banners:                                '/banner/{lang}/',
        banners_update:                         '/banner/{lang}/{banner_id}',
        banners_activate:                       '/banner/{lang}/activate/{banner_id}/{isactive}',

        tv:                                     '/tv/{lang}/',
        tv_lazy:                                '/tv/{lang}/lazy',
        tv_list:                                '/tv/{lang}/list',
        tv_update:                              '/tv/{lang}/{tv_id}',
        tv_activate:                            '/tv/{lang}/activate/{tv_id}/{isactive}',

        category:                               '/category/{lang}/',
        category_list:                          '/category/{lang}/list',
        category_update:                        '/category/{lang}/{category_id}',
        category_activate:                      '/category/{lang}/activate/{category_id}/{isactive}',

        filter:                                 '/filter/{lang}/',
        filter_list:                            '/filter/{lang}/list',
        filter_update:                          '/filter/{lang}/{filter_id}',
        filter_group_with_filters:              '/filter/{lang}/{filter_id}/with_filters',
        filter_activate:                        '/filter/{lang}/activate/{filter_id}/{isactive}',
        filters_by_group:                       '/filter/{lang}/filters_by_group/{filter_id}',

        author:                                 '/author/{lang}/',
        author_list:                            '/author/{lang}/list',
        author_lazy:                            '/author/{lang}/lazy',
        author_update:                          '/author/{lang}/{author_id}',
        author_image_remove:                    '/author/{lang}/{author_id}/images',
        author_activate:                        '/author/{lang}/activate/{author_id}/{isactive}',
        author_publish_activate:                '/author/{lang}/publish_activate/{author_id}/{isactive}',

        post:                                   '/post/{lang}/',
        post_lazy:                              '/post/{lang}/lazy',
        post_update:                            '/post/{lang}/{post_id}',
        post_image_remove:                      '/post/{lang}/{post_id}/images',
        post_activate:                          '/post/{lang}/activate/{post_id}/{isactive}',
        post_main_activate:                     '/post/{lang}/main_activate/{post_id}/{isactive}',
        post_publish_activate:                  '/post/{lang}/publish_activate/{post_id}/{isactive}',

        social_network:                         '/social_network/{lang}/',
        social_network_update:                  '/social_network/{lang}/{social_network_id}',
        social_network_activate:                '/social_network/{lang}/activate/{social_network_id}/{isactive}',

        contact:                                '/contact/{lang}/',
        contact_lazy:                           '/contact/{lang}/lazy',
        contact_update:                         '/contact/{lang}/{contact_id}',
    },

    getters: {
        getAllDataTableParams: (state) => (name) => {
            return state.allDataTableParams[name];
        },
        setAllDataTableParams: (state) => (name, value) => {
            if( value === undefined ){
                value = {
                    first: 0,
                    originalEvent: {
                        first: 0,
                        page: 1,
                        rows: G.rowsPerPage
                    },
                    page: 1,
                    rows: G.rowsPerPage,
                    mainFilters: {},
                    multiSortMeta: [],
                    filters: ''
                };
            }
            state.allDataTableParams[name] = value;
        },


        // ---------------------------------------------------------------------------------------------
        getMenu: (state) => () => {
            return state.api.menu.replace('{lang}', state.lang);
        },
        getMenuList: (state) => () => {
            return state.api.menu_list.replace('{lang}', state.lang);
        },
        getMenuUpdate: (state) => (menu_id) => {
            return state.api.menu_update.replace('{lang}', state.lang).replace('{menu_id}', menu_id);
        },
        getMenuActivate: (state) => (menu_id, isactive) => {
            return state.api.menu_activate.replace('{lang}', state.lang).replace('{menu_id}', menu_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getBanners: (state) => () => {
            return state.api.banners.replace('{lang}', state.lang);
        },
        getBannersUpdate: (state) => (banner_id) => {
            return state.api.banners_update.replace('{lang}', state.lang).replace('{banner_id}', banner_id);
        },
        getBannersActivate: (state) => (banner_id, isactive) => {
            return state.api.banners_activate.replace('{lang}', state.lang).replace('{banner_id}', banner_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getCategory: (state) => () => {
            return state.api.category.replace('{lang}', state.lang);
        },
        getCategoryList: (state) => () => {
            return state.api.category_list.replace('{lang}', state.lang);
        },
        getCategoryUpdate: (state) => (category_id) => {
            return state.api.category_update.replace('{lang}', state.lang).replace('{category_id}', category_id);
        },
        getCategoryActivate: (state) => (category_id, isactive) => {
            return state.api.category_activate.replace('{lang}', state.lang).replace('{category_id}', category_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getFilter: (state) => () => {
            return state.api.filter.replace('{lang}', state.lang);
        },
        getFilterList: (state) => () => {
            return state.api.filter_list.replace('{lang}', state.lang);
        },
        getFilterUpdate: (state) => (filter_id) => {
            return state.api.filter_update.replace('{lang}', state.lang).replace('{filter_id}', filter_id);
        },
        getFilterGroupWithFilters: (state) => (filter_id) => {
            return state.api.filter_group_with_filters.replace('{lang}', state.lang).replace('{filter_id}', filter_id);
        },
        getFilterActivate: (state) => (filter_id, isactive) => {
            return state.api.filter_activate.replace('{lang}', state.lang).replace('{filter_id}', filter_id).replace('{isactive}', isactive);
        },
        getFiltersByGroupID: (state) => (filter_id) => {
            return state.api.filters_by_group.replace('{lang}', state.lang).replace('{filter_id}', filter_id);
        },

        // ---------------------------------------------------------------------------------------------
        getAuthor: (state) => () => {
            return state.api.author.replace('{lang}', state.lang);
        },
        getAuthorList: (state) => () => {
            return state.api.author_list.replace('{lang}', state.lang);
        },
        getAuthorLazy: (state) => () => {
            return state.api.author_lazy.replace('{lang}', state.lang);
        },
        getAuthorUpdate: (state) => (author_id) => {
            return state.api.author_update.replace('{lang}', state.lang).replace('{author_id}', author_id);
        },
        getAuthorImageRemove: (state) => (author_id) => {
            return state.api.author_image_remove.replace('{lang}', state.lang).replace('{author_id}', author_id);
        },
        getAuthorActivate: (state) => (author_id, isactive) => {
            return state.api.author_activate.replace('{lang}', state.lang).replace('{author_id}', author_id).replace('{isactive}', isactive);
        },
        getAuthorPublishActivate: (state) => (author_id, isactive) => {
            return state.api.author_publish_activate.replace('{lang}', state.lang).replace('{author_id}', author_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getPost: (state) => () => {
            return state.api.post.replace('{lang}', state.lang);
        },
        getPostLazy: (state) => () => {
            return state.api.post_lazy.replace('{lang}', state.lang);
        },
        getPostUpdate: (state) => (post_id) => {
            return state.api.post_update.replace('{lang}', state.lang).replace('{post_id}', post_id);
        },
        getPostImageRemove: (state) => (post_id) => {
            return state.api.post_image_remove.replace('{lang}', state.lang).replace('{post_id}', post_id);
        },
        getPostActivate: (state) => (post_id, isactive) => {
            return state.api.post_activate.replace('{lang}', state.lang).replace('{post_id}', post_id).replace('{isactive}', isactive);
        },
        getPostMainActivate: (state) => (post_id, isactive) => {
            return state.api.post_main_activate.replace('{lang}', state.lang).replace('{post_id}', post_id).replace('{isactive}', isactive);
        },
        getPostPublishActivate: (state) => (post_id, isactive) => {
            return state.api.post_publish_activate.replace('{lang}', state.lang).replace('{post_id}', post_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getTV: (state) => () => {
            return state.api.tv.replace('{lang}', state.lang);
        },
        getTVLazy: (state) => () => {
            return state.api.tv_lazy.replace('{lang}', state.lang);
        },
        getTVList: (state) => () => {
            return state.api.tv_list.replace('{lang}', state.lang);
        },
        getTVUpdate: (state) => (tv_id) => {
            return state.api.tv_update.replace('{lang}', state.lang).replace('{tv_id}', tv_id);
        },
        getTVActivate: (state) => (tv_id, isactive) => {
            return state.api.tv_activate.replace('{lang}', state.lang).replace('{tv_id}', tv_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getSocialNetwork: (state) => () => {
            return state.api.social_network.replace('{lang}', state.lang);
        },
        getSocialNetworkUpdate: (state) => (social_network_id) => {
            return state.api.social_network_update.replace('{lang}', state.lang).replace('{social_network_id}', social_network_id);
        },
        getSocialNetworkActivate: (state) => (social_network_id, isactive) => {
            return state.api.social_network_activate.replace('{lang}', state.lang).replace('{social_network_id}', social_network_id).replace('{isactive}', isactive);
        },

        // ---------------------------------------------------------------------------------------------
        getContact: (state) => () => {
            return state.api.contact.replace('{lang}', state.lang);
        },
        getContactLazy: (state) => () => {
            return state.api.contact_lazy.replace('{lang}', state.lang);
        },
        getContactUpdate: (state) => (contact_id) => {
            return state.api.contact_update.replace('{lang}', state.lang).replace('{contact_id}', contact_id);
        },
    },
    actions: {
        //
    }

};
